<!-- Ported from the Polaris kit: src/components/ui/progress/Progress.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port.
     Hand change (phase P): the fill is `modelValue / max` (the registry assumed max = 100 and ignored `max`). -->
<script setup>
import { computed } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { ProgressIndicator, ProgressRoot } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  modelValue: { type: [Number, null], required: false, default: 0 },
  max: { type: Number, required: false },
  getValueLabel: { type: Function, required: false },
  getValueText: { type: Function, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class');
// How far the bar is filled, out of `max` (reka's default is 100).
const percent = computed(
  () => ((props.modelValue ?? 0) / (props.max ?? 100)) * 100
);
</script>

<template>
  <ProgressRoot
    data-slot="progress"
    v-bind="delegatedProps"
    :class="
      cn(
        'bg-polaris-primary/20 relative h-2 w-full overflow-hidden rounded-full',
        props.class
      )
    "
  >
    <ProgressIndicator
      data-slot="progress-indicator"
      class="bg-polaris-primary h-full w-full flex-1 transition-all"
      :style="`transform: translateX(-${100 - percent}%);`"
    />
  </ProgressRoot>
</template>
